import classic from 'ember-classic-decorator';

import ApplicationAdapter from './application';

@classic
export default class MentionAdapter extends ApplicationAdapter {
  namespace = '/api/v2/analytics';
}
